import {useSelector} from 'react-redux'
import {useIsSrpSearchSeoFlow} from 'hooks/useIsSrpSearchSeoFlow'
import {useGetHotelDescriptionQuery} from 'modules/seoApi'
import {getHotelDescriptionParams} from 'modules/seoApi/selectors'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import type {HotelDescription} from 'seo/seo-db/queries/hotelDescription'
import type {RootState} from 'store'

/**
 * The GenAI description from seo-db, only on the SEO AP. Undefined
 * everywhere else and while there is none, so callers keep the SAPI text.
 */
export const useSeoHotelDescription = (
  hotelId?: string
): HotelDescription | undefined => {
  const toggle = useToggle()
  const isSeoFlow = useIsSrpSearchSeoFlow()
  const isEnabled =
    Boolean(hotelId) &&
    isSeoFlow &&
    toggle('feature-seo-hotel-descriptions', false, true)

  const params = useSelector((state: RootState) =>
    getHotelDescriptionParams(state, hotelId)
  )

  const {description} = useGetHotelDescriptionQuery(params, {
    selectFromResult: result => ({description: result?.data?.description}),
    skip: !isEnabled
  })

  return description
}
